import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { VrComponent } from './components/vr/vr.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    title: 'FC Lugano VR',
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'Login Lugano VR'
  },
  {
    path: 'experience/vr',
    component: VrComponent,
    title: 'VR Experience'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
